import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ITranslatableText } from 'src/app/store/services/store.service';

/////////////////////////////////////////////////
// global Data

/*
export interface IAllergen {
  id: string;
  merchantId: string;
  name: ITranslatableText;
  isActive: boolean;
}
  */

/*
export interface IFlavor {
  id: string;
  merchantId: string;
  name: ITranslatableText;
  isActive: boolean;
}
*/

/*
export interface INutrition {
  id: string;
  merchantId: string;
  name: ITranslatableText;
  isActive: boolean;
}*/

/*
export interface IFindAllergen {
  merchantId: string;
}
*/

/*
export interface IFindFlavor {
  merchantId: string;
}
*/

/*
export interface IFindNutrition {
  merchantId: string;
}
*/

/////////////////////////////////////////////////////////////////////
// new fromat for the API calls

export interface IFindNutrition {
  merchantId?: string;
  deepSearch?: boolean;
  itemIds?: string[];
  page?: number;
  pageSize?: number;
}

export interface INutrition {
  id?: string;
  merchantId?: string;
  nutritions?: INutritionConfig[];
  itemIds?: string[];
  items?: any[];
}

export interface INutritionConfig {
  name?: ITranslatableText;
  itemValues?: IItemNutritionValues[];
  isActive?: boolean;
}

export interface IItemNutritionValues {
  itemId?: string;
  value?: number;
  itemIndex?: number;

  _index?: number;
  _name?: ITranslatableText;
}

/////////////////////////////////////////////////////////////////////

export interface IFindAllergen {
  merchantId?: string;
  deepSearch?: boolean;
  itemIds?: string[];
  page?: number;
  pageSize?: number;
}

export interface IAllergen {
  id?: string;
  merchantId?: string;
  allergens?: IAllergenConfig[];
  itemIds?: string[];
  items?: any[];
}

export interface IAllergenConfig {
  name?: ITranslatableText;
  itemValues?: IItemAllergenValues[];
  isActive?: boolean;
}

export interface IItemAllergenValues {
  itemId?: string;
  value?: number; // this one is using a value of 0-1-2 as enums
  itemIndex?: number;

  _index?: number;
  _name?: ITranslatableText;
}

/////////////////////////////////////////////////////////////////////

export interface IFindFlavor {
  merchantId?: string;
  deepSearch?: boolean;
  itemIds?: string[];
  page?: number;
  pageSize?: number;
}

export interface IFlavor {
  id?: string;
  merchantId?: string;
  flavors?: IFlavorConfig[];
  itemIds?: string[];
  items?: any[];
}

export interface IFlavorConfig {
  name?: ITranslatableText;
  itemValues?: IItemFlavorValues[];
  isActive?: boolean;
}

export interface IItemFlavorValues {
  itemId?: string;
  value?: boolean;
  itemIndex?: number;

  _index?: number;
  _name?: ITranslatableText;
}

/////////////////////////////////////////////////////////////////////

@Injectable({
  providedIn: 'root',
})
export class AllergenNutritionFlavorService {

  constructor(
    private http: HttpClient,
    private settingService: SettingService,
    //private imageService: ImageService,
    private apiController: ApiControllerService
  ) { }

  
  getAllergens(AllergensRequest: IFindAllergen): Observable<IAllergen> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('NutritionAllergen/FindAllAllergen'), AllergensRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */
      this.apiController.post(this.settingService.apiUrl('NutritionAllergen/FindAllAllergen'), AllergensRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

  getFlavors(FlavorsRequest: IFindFlavor): Observable<IFlavor> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('NutritionAllergen/FindAllFlavor'), FlavorsRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */

      this.apiController.post(this.settingService.apiUrl('NutritionAllergen/FindAllFlavor'), FlavorsRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

  getNutritions(NutritionsRequest: IFindNutrition): Observable<INutrition> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('NutritionAllergen/FindAllNutrition'), NutritionsRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */

      this.apiController.post(this.settingService.apiUrl('NutritionAllergen/FindAllNutrition'), NutritionsRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

  // item based APIs
  
}
